import React, { useEffect, useMemo } from 'react';
import { Layout } from 'tea-component';
import TimezoneTips from '../TimezoneTips';
import {
  DEFAULT_PAGE_URL,
  defaultPageList,
  useGetPageRule,
} from '@op/hooks/useGetPageSourceRule';
import CommonLock from '../CommonLock';
import { PAGE_NAME } from '@op/constants/page';
import { FilterPageNameContext } from './context';
import { useHistory } from 'umi';
import { TipsMapType } from '../BubbleCommon';
import CardLoading from '../CardLoading';

const { Content } = Layout;
export default function ContentBody({
  children,
  contentHeard,
  pageName,
  parentPageName,
  GotoFeeds,
  horseRaceLampTips,
  isInfluencer,
  noShowTimeZoneTips,
  hidePageHeader = false,
  hideTips = false,
  loading: externalLoading = false,
  cardLoadingStyle = {},
  ...otherProps
}: {
  children:
  | JSX.Element
  | Array<JSX.Element>
  | (() => JSX.Element | Array<JSX.Element>);
  pageName?: PAGE_NAME;
  parentPageName?: PAGE_NAME;
  contentHeard?: JSX.Element;
  GotoFeeds?: boolean;
  horseRaceLampTips?: TipsMapType | Array<TipsMapType>;
  isInfluencer?: boolean;
  noShowTimeZoneTips?: boolean;
  hidePageHeader?: boolean;
  hideTips?: boolean;
  loading?: boolean;
  cardLoadingStyle?: React.CSSProperties;
  [key: string]: any;
}) {
  const history = useHistory();
  const {
    wholeGameInfo,
    menuId,
    showTips,
    emptyDescText,
    emptyTitleText,
    loading,
    noPage,
  } = useGetPageRule({
    menuName: pageName,
    parentPageName,
  });

  const childrenElement =
    typeof children === 'function' ? children() : children;

  const provideMemo = useMemo(() => ({ menuId, pageName }), [menuId]);

  useEffect(() => {
    if (GotoFeeds && noPage && !loading) {
      const item = defaultPageList.find(
        (item) => item.pageName === PAGE_NAME.FEEDS,
      );
      history.push(item?.url || DEFAULT_PAGE_URL);
    }
  }, [noPage]);

  const hide = !(showTips || loading);
  return (
    <FilterPageNameContext.Provider value={provideMemo}>
      {hide && !hidePageHeader && contentHeard}
      <Content.Body {...otherProps} full>
        {hide && !hideTips && (
          <>
            {/* <CommonTips wholeGameInfo={wholeGameInfo}></CommonTips> */}
            <TimezoneTips
              horseRaceLampTips={horseRaceLampTips}
              wholeGameInfo={wholeGameInfo}
              isInfluencer={isInfluencer}
              noShowTimeZoneTips={noShowTimeZoneTips}
            ></TimezoneTips>
          </>
        )}
        <CommonLock
          emptyTitleText={emptyTitleText}
          emptyDescText={emptyDescText}
          loading={loading || (noPage && GotoFeeds)}
          empty={showTips}
          contentCard={hide}
        >
          <CardLoading
            wrapperStyle={{ marginTop: 0, ...cardLoadingStyle }}
            loading={externalLoading}
          >
            {childrenElement}
          </CardLoading>
        </CommonLock>
      </Content.Body>
    </FilterPageNameContext.Provider>
  );
}
